"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var react_hot_toast_1 = require("react-hot-toast");
var api_service_1 = require("../../../api/api_service");
var generic_api_calls_1 = require("../../generic_api_calls");
var button_component_1 = require("../../../common/buttons/button_component");
var DownloadLinkComponent = function (_a) {
    var filePath = _a.filePath, reportID = _a.reportID, name = _a.name;
    var _b = React.useState(false), loading = _b[0], setLoading = _b[1];
    var handleDownloadClick = function () { return __awaiter(void 0, void 0, void 0, function () {
        var res, downloadUrl, anchor, err_1;
        var _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    if (!filePath)
                        return [2];
                    setLoading(true);
                    _c.label = 1;
                case 1:
                    _c.trys.push([1, 5, 6, 7]);
                    return [4, (0, generic_api_calls_1.fetchImnageURLFromName)(filePath)];
                case 2:
                    res = _c.sent();
                    downloadUrl = (_b = (_a = res === null || res === void 0 ? void 0 : res.data) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.url;
                    if (!downloadUrl)
                        throw new Error('Download URL not found');
                    if (!(name === 'visit' && reportID)) return [3, 4];
                    return [4, api_service_1.api_service
                            .post({
                            endPoint: api_service_1.api_service.api_urls.DOWNLOADREPORT_HISTORY,
                            domain: process.env.APPROVAL_BASEURL,
                            payLoad: { id: reportID },
                        })
                            .then(function (res) {
                            var _a;
                            if (res.data.statusCode !== 200) {
                                var errorMessage = ((_a = res.data) === null || _a === void 0 ? void 0 : _a.message) || 'Unable to save download history';
                                throw new Error(errorMessage);
                            }
                        })];
                case 3:
                    _c.sent();
                    _c.label = 4;
                case 4:
                    anchor = document.createElement('a');
                    anchor.href = downloadUrl;
                    anchor.download = '';
                    document.body.appendChild(anchor);
                    anchor.click();
                    document.body.removeChild(anchor);
                    return [3, 7];
                case 5:
                    err_1 = _c.sent();
                    react_hot_toast_1.default.error((err_1 === null || err_1 === void 0 ? void 0 : err_1.message) || 'Download failed');
                    return [3, 7];
                case 6:
                    setLoading(false);
                    return [7];
                case 7: return [2];
            }
        });
    }); };
    return (React.createElement("div", null, filePath ? (React.createElement(button_component_1.default, { buttonName: 'Download', color: 'yellow-outline', onClickHandler: handleDownloadClick, isError: loading, sx: { fontSize: '9px !important' } }, loading ? 'Downloading...' : 'Download')) : (React.createElement("p", null, "--"))));
};
exports.default = DownloadLinkComponent;
